<app-breadcrumb [master]="'ASF360'" [parentName]="'Tagi'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-tags-details-view *ngIf="!modify" [tag]="tag" (modifyClicked)="modify = true"></app-tags-details-view>
    <app-tags-add *ngIf="modify" [tag]="tagObject" [mod]='true' (closeModification)="modify = false; load()" ></app-tags-add>
  </mat-tab>

</mat-tab-group>

